export function PurposeQuote() {
  return (
    <section className="mx-auto w-full max-w-4xl px-6 py-28 text-center sm:py-36">
      <div data-reveal="" style={{ ["--reveal-delay" as string]: "0ms" }}>
        <p className="text-balance text-3xl font-medium leading-snug tracking-tight sm:text-[2.6rem] sm:leading-[1.15]">
          给今天的久坐按下暂停键。{" "}
          <span className="font-display text-[1.1em] italic text-muted-foreground">
            下载官方发行版，或查看源码自构建。
          </span>{" "}
          提醒文字、工作时段和白名单都可以按你的桌面节奏配置。
        </p>
      </div>
    </section>
  );
}
